import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { UserListModel, UserModel } from '@ninety/mobile/platform/api';

export const UserListStateActions = createActionGroup({
  source: 'User List',
  events: {
    Fetch: emptyProps(),
    'Fetch Success': props<{ users: UserListModel[] }>(),
    'Fetch Error': props<{ error: unknown }>(),
    'Set Logged In User Id': props<{ loggedInUserId: string }>(),
    'Set Logged In User': props<{ loggedInUser: UserModel }>(),
    'Update Logged In User': props<{ update: Partial<UserModel> }>(),
    'Update Logged In User Success': props<{ update: Partial<UserModel> }>(),
    'Update Logged In User Error': props<{ error: unknown }>(),
  },
});
